import { chain, get } from "lodash"

// Hard coded until we implement the selector in the UI
export const getThresholdParams = () => ({ value: 0.5, isPercent: true })

export const getFactorSensitivityType = (state, props) =>
  get(props, "factorSensitivityType") || chain(props)
    .get("params.factorSensitivityType")
    .toUpper()
    .value()
